<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="errors.length > 0">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <br/>
        <div class="container">
            <div class="row">
                <div class="form-group col-6">
                    <label class="mb-1" for="balancerName">Balancer Name</label>
                    <input v-model="balancer.name" type="text" class="form-control" id="balancerName"
                           placeholder="Example: Gmail">
                    <div v-if="$v.balancer.name.$error">
                        <div class="text-danger" v-if="!$v.balancer.name.required">Balancer Name is required</div>
                        <div class="text-danger" v-if="!$v.balancer.name.maxLength">Balancer Name must be no longer than
                            {{$v.balancer.name.$params.maxLength.max }} characters
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="domainMicro">Domain Macro</label>
                    <input v-model="balancer.domainMacro" type="text" class="form-control" id="domainMicro"
                           placeholder="Example: gmail gmail.ru gmail.com">
                    <div class="text-danger" v-if="$v.balancer.domainMacro.$error">
                        Balancer Domain Macro is required
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="maxSmtpOut">Max Smtp Out</label>
                    <input v-model.number="balancer.maxSmtpOut" type="text" class="form-control" id="maxSmtpOut"
                           placeholder="Default: 20 for domain">
                    <div v-if="$v.balancer.maxSmtpOut.$error">
                        <div class="text-danger" v-if="!$v.balancer.maxSmtpOut.required">
                            Balancer Max Smtp Out is required
                        </div>
                        <div class="text-danger" v-if="!$v.balancer.maxSmtpOut.integer">
                            Balancer Max Smtp Out must be integer
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="maxMsgPerConnection">Max Msg Per Connection</label>
                    <input v-model.number="balancer.maxMsgPerConnection" type="text" id="maxMsgPerConnection"
                           class="form-control"
                           placeholder="max 500 mails in one session">
                    <div v-if="$v.balancer.maxMsgPerConnection.$error">
                        <div class="text-danger" v-if="!$v.balancer.maxMsgPerConnection.required">
                            Balancer Max Msg Per Connection is required
                        </div>
                        <div class="text-danger" v-if="!$v.balancer.maxMsgPerConnection.integer">
                            Balancer Max Msg Per Connection must be integer
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="maxErrorsPerConnection">Max Errors Per Connection</label>
                    <input v-model.number="balancer.maxErrorsPerConnection" type="text" id="maxErrorsPerConnection"
                           class="form-control"
                           placeholder="Example: 10, Default: unlimited">
                    <div v-if="$v.balancer.maxErrorsPerConnection.$error">
                        <div class="text-danger" v-if="!$v.balancer.maxErrorsPerConnection.required">
                            Balancer Max Errors Per Connection is required
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="maxMsgRate">Max Msg Rate <i>(It accepts the following values:
                        "unlimited", "N/h" or “N/hr” (for per-hour), "N/m" or “N/min” (for per-minute)
                        and "N/s" or “N/sec” (for per-second). )</i>
                    </label>
                    <input v-model="balancer.maxMsgRate" type="text" id="maxMsgRate" class="form-control"
                           placeholder="Example: 50/s, Default: unlimited">
                    <div v-if="$v.balancer.maxMsgRate.$error">
                        <div class="text-danger" v-if="!$v.balancer.maxMsgRate.required">
                            Balancer Max Msg Rate is required
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="bounceUponNoMx">Bounce Upon No Mx</label>
                    <div>
                        <toggle-button
                                :value="balancer.bounceUponNoMx"
                                :sync="true"
                                id="bounceUponNoMx"
                                :labels="{checked: 'Yes', unchecked: 'No'}"
                                :height="26" :width="52"/>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="assumeDeliveryTimeout">Assume Delivery Timeout</label>
                    <div>
                        <toggle-button
                                :value="balancer.assumeDeliveryTimeout"
                                :sync="true"
                                id="assumeDeliveryTimeout"
                                :labels="{checked: 'Yes', unchecked: 'No'}"
                                :height="26" :width="52"/>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="smtpMxUnavailable">Smtp Mx Unavailable</label>
                    <div>
                        <toggle-button
                                :value="balancer.smtpMxUnavailable"
                                :sync="true"
                                id="smtpMxUnavailable"
                                :labels="{checked: 'Yes', unchecked: 'No'}"
                                :height="26" :width="52"/>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="smtpInvalidMailbox">Smtp Invalid Mailbox</label>
                    <div>
                        <toggle-button
                                :value="balancer.smtpInvalidMailbox"
                                :sync="true"
                                id="smtpInvalidMailbox"
                                :labels="{checked: 'Yes', unchecked: 'No'}"
                                :height="26" :width="52"/>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label for="bounceUponGreeting">Bounce Upon Greeting</label>
                    <div>
                        <toggle-button
                                :value="balancer.bounceUponGreeting"
                                :sync="true"
                                id="bounceUponGreeting"
                                :labels="{checked: 'Yes', unchecked: 'No'}"
                                :height="26" :width="52"/>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="connectTimeout">Connect Timeout</label>
                    <input v-model="balancer.connectTimeout" type="text" class="form-control" id="connectTimeout"
                           placeholder="Example: 1m, Default: 2m">
                    <div v-if="$v.balancer.connectTimeout.$error">
                        <div class="text-danger" v-if="!$v.balancer.connectTimeout.maxLength">
                            Connect Timeout must be no longer than
                            {{$v.balancer.connectTimeout.$params.maxLength.max }} characters
                        </div>
                        <div class="text-danger" v-if="!$v.balancer.connectTimeout.required">
                            Connect Timeout is required
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="smtpGreetingTimeout">Smtp Greeting Timeout</label>
                    <input v-model="balancer.smtpGreetingTimeout" type="text" id="smtpGreetingTimeout"
                           placeholder="Default: 5m"
                           class="form-control">
                    <div class="text-danger" v-if="$v.balancer.smtpGreetingTimeout.$error">
                        <div class="text-danger" v-if="!$v.balancer.smtpGreetingTimeout.required">
                            Smtp Greeting Timeout is required
                        </div>
                        <div class="text-danger" v-if="!$v.balancer.smtpGreetingTimeout.maxLength">
                            Smtp Greeting Timeout must be no longer than
                            {{$v.balancer.smtpGreetingTimeout.$params.maxLength.max }} characters
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="dataSendTimeout">Data Send Timeout</label>
                    <input v-model="balancer.dataSendTimeout" type="text" id="dataSendTimeout" class="form-control"
                           placeholder="Default: 3m">
                    <div class="text-danger" v-if="$v.balancer.dataSendTimeout.$error">
                        <div class="text-danger" v-if="!$v.balancer.dataSendTimeout.required">
                            Data Send Timeout is required
                        </div>
                        <div class="text-danger" v-if="!$v.balancer.dataSendTimeout.maxLength">
                            Data Send Timeout must be no longer than
                            {{$v.balancer.dataSendTimeout.$params.maxLength.max }} characters
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="retryAfter">Retry After</label>
                    <input v-model="balancer.retryAfter" type="text" id="retryAfter" class="form-control"
                           placeholder="Example: 1h, Default: 20m">
                    <div class="text-danger" v-if="$v.balancer.retryAfter.$error">
                        <div class="text-danger" v-if="!$v.balancer.retryAfter.required">
                            Retry After is required
                        </div>
                        <div class="text-danger" v-if="!$v.balancer.retryAfter.maxLength">
                            Retry After must be no longer than
                            {{$v.balancer.retryAfter.$params.maxLength.max }} characters
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="bounceAfter">Bounce After</label>
                    <input v-model="balancer.bounceAfter" type="text" id="bounceAfter" class="form-control"
                           placeholder="Example: 15d, Default: 4d12h">
                    <div class="text-danger" v-if="$v.balancer.retryAfter.$error">
                        <div class="text-danger" v-if="!$v.balancer.bounceAfter.required">
                            Bounce After is required
                        </div>
                        <div class="text-danger" v-if="!$v.balancer.bounceAfter.maxLength">
                            Bounce After must be no longer than
                            {{$v.balancer.bounceAfter.$params.maxLength.max }} characters
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="smtpPatternList">Smtp Pattern List</label>
                    <input v-model.number="balancer.smtpPatternList" type="text" id="smtpPatternList"
                           class="form-control"
                           placeholder="Example: blocking-errors, Default: none">
                    <div class="text-danger" v-if="$v.balancer.smtpPatternList.$error">
                        <div class="text-danger" v-if="!$v.balancer.smtpPatternList.required">
                            Smtp Pattern List is required
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="backoffMaxMsgRate">Backoff Max Msg Rate</label>
                    <input v-model="balancer.backoffMaxMsgRate" type="text" id="backoffMaxMsgRate" class="form-control"
                           placeholder="Example: 1/h, Default: unlimited">
                    <div class="text-danger" v-if="$v.balancer.backoffMaxMsgRate.$error">
                        <div class="text-danger" v-if="!$v.balancer.backoffMaxMsgRate.required">
                            Backoff Max Msg Rate is required
                        </div>
                        <div class="text-danger" v-if="!$v.balancer.backoffMaxMsgRate.maxLength">
                            Backoff Max Msg Rate must be no longer than
                            {{$v.balancer.backoffMaxMsgRate.$params.maxLength.max }} characters
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="backoffRetryAfter">Backoff Retry After</label>
                    <input v-model="balancer.backoffRetryAfter" type="text" id="backoffRetryAfter" class="form-control"
                           placeholder="Example: 1/h, Default: 1h">
                    <div class="text-danger" v-if="$v.balancer.backoffRetryAfter.$error">
                        <div class="text-danger" v-if="!$v.balancer.backoffRetryAfter.required">
                            Backoff Retry After is required
                        </div>
                        <div class="text-danger" v-if="!$v.balancer.backoffRetryAfter.maxLength">
                            Backoff Retry After must be no longer than
                            {{$v.balancer.backoffRetryAfter.$params.maxLength.max }} characters
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="backoffToNormalAfterDelivery">Backoff To Normal After Delivery</label>
                    <div>
                        <toggle-button
                                :value="balancer.backoffToNormalAfterDelivery"
                                id="backoffToNormalAfterDelivery"
                                :labels="{checked: 'Yes', unchecked: 'No'}"
                                :height="26" :width="52"/>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="backoffToNormalAfter">Backoff To Normal After</label>
                    <input v-model="balancer.backoffToNormalAfter" type="text" id="backoffToNormalAfter"
                           class="form-control"
                           placeholder="Default: never, possible variants: {N d|h|m|s|}">
                    <div class="text-danger" v-if="$v.balancer.backoffToNormalAfter.$error">
                        <div class="text-danger" v-if="!$v.balancer.backoffToNormalAfter.required">
                            Backoff To Normal After is required
                        </div>
                        <div class="text-danger" v-if="!$v.balancer.backoffToNormalAfter.maxLength">
                            Backoff To Normal After must be no longer than
                            {{$v.balancer.backoffToNormalAfter.$params.maxLength.max }} characters
                        </div>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="dkSign">Dk Sign</label>
                    <div>
                        <toggle-button
                                v-model="balancer.dkSign"
                                :sync="true"
                                id="dkSign"
                                :labels="{checked: 'Yes', unchecked: 'No'}"
                                :height="26" :width="52"/>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="dkimSign">Dkim Sign</label>
                    <div>
                        <toggle-button
                                v-model="balancer.dkimSign"
                                :sync="true"
                                id="dkimSign"
                                :labels="{checked: 'Yes', unchecked: 'No'}"
                                :height="26" :width="52"/>
                    </div>
                </div>
                <div class="form-group col-6">
                    <label class="mb-1" for="deliverLocalDsn">Deliver Local Dsn</label>
                    <div>
                        <toggle-button
                                v-model="balancer.deliverLocalDsn"
                                :sync="true"
                                id="deliverLocalDsn"
                                :labels="{checked: 'Yes', unchecked: 'No'}"
                                :height="26" :width="52"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group text-center p-b-20  p-t-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                        v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {required, integer, maxLength} from 'vuelidate/lib/validators';
    import BalancerService from '../../services/MailServiceSettingService';

    export default {
        name: 'MailServiceSettingForm',
        data() {
            return {
                balancer: {
                    name: null,
                    domainMacro: null,
                    maxSmtpOut: 20,
                    maxMsgPerConnection: 0,
                    maxErrorsPerConnection: 'unlimited',
                    maxMsgRate: 'unlimited',
                    bounceUponNoMx: false,
                    assumeDeliveryTimeout: false,
                    smtpMxUnavailable: false,
                    smtpInvalidMailbox: true,
                    bounceUponGreeting: true,
                    connectTimeout: '2m',
                    smtpGreetingTimeout: '5m',
                    dataSendTimeout: '3m',
                    retryAfter: '10m',
                    bounceAfter: '4d12h',
                    smtpPatternList: 'blocking-errors',
                    backoffMaxMsgRate: 'unlimited',
                    backoffRetryAfter: '1h',
                    backoffToNormalAfterDelivery: false,
                    backoffToNormalAfter: 'never',
                    dkSign: false,
                    dkimSign: false,
                    deliverLocalDsn: true,
                },
                errors: {},
                submitting: false
            }
        },
        mounted() {
            if (this.$route.params.id) {
                BalancerService.getMailServiceSetting(this.$route.params.id).then(response => {
                    this.balancer = response.data;
                    this.$emit('setLoading', false)
                });
            }
        },
        validations: {
            balancer: {
                name: {required, maxLength: maxLength(100)},
                domainMacro: {required},
                maxSmtpOut: {required, integer},
                maxMsgPerConnection: {required, integer},
                maxErrorsPerConnection: {required},
                maxMsgRate: {required},
                connectTimeout: {maxLength: maxLength(100), required},
                smtpGreetingTimeout: {maxLength: maxLength(100), required},
                dataSendTimeout: {maxLength: maxLength(100), required},
                retryAfter: {maxLength: maxLength(100), required},
                bounceAfter: {maxLength: maxLength(100), required},
                smtpPatternList: {required},
                backoffMaxMsgRate: {maxLength: maxLength(100), required},
                backoffRetryAfter: {maxLength: maxLength(100), required},
                backoffToNormalAfter: {maxLength: maxLength(100), required},
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.submitting = true;
                let submitMethod = null;

                if (this.$route.params.id) {
                    submitMethod = BalancerService.updateMailServiceSettings(this.$route.params.id, JSON.stringify(this.balancer));
                } else {
                    submitMethod = BalancerService.createMailServiceSettings(this.balancer);
                }

                submitMethod.then(response => {
                    this.submitting = false;
                    if (response.data.error !== undefined) {
                        this.errors = response.data.error;
                    } else {
                        this.$router.push({name: 'mailServiceSettings'});
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
